// auto-generated by Typewriter template _enums.tst from PortCall.Models\Sharing\Share.cs
export enum ShareType { 
    Viewer = 1,
    Editor = 2,
    Owner = 61440,
    All = 65535,
    None = 0
}

export const ShareTypeDisplayName : { [val : number] : string } = { 
    1: 'Viewer',
    2: 'Editor',
    61440: 'Owner',
    65535: 'All',
    0: 'None'
}

export const ShareTypes : { Id : ShareType, Name : string }[] = [ 
    { Id: ShareType.Viewer, Name: 'Viewer' },
    { Id: ShareType.Editor, Name: 'Editor' },
    { Id: ShareType.Owner, Name: 'Owner' },
    { Id: ShareType.All, Name: 'All' },
    { Id: ShareType.None, Name: 'None' }
]



// WEBPACK FOOTER //
// ./server/enums/ShareType.ts